import { render, staticRenderFns } from "./NoticePopup.vue?vue&type=template&id=05791c80&scoped=true&"
import script from "./NoticePopup.vue?vue&type=script&lang=js&"
export * from "./NoticePopup.vue?vue&type=script&lang=js&"
import style0 from "./NoticePopup.vue?vue&type=style&index=0&id=05791c80&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../cache/node/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05791c80",
  null
  
)

export default component.exports